/* eslint-disable react-hooks/rules-of-hooks */
import React, { memo, FC, useCallback, useRef } from 'react';
import classNames from 'classnames';
import {
  Button,
  CardFooter,
  makeStyles,
  shorthands,
} from '@fluentui/react-components';

export interface IFooterButtonConfig {
  text: string;
  onClick: () => void;
  appearance?: undefined | 'subtle';
  analyticsId?: string;
  helpId?: string;
  className?: string;
}


export interface IFooterProps {
  footerButtonConfigs?: IFooterButtonConfig[];
  renderPagination?: () => React.ReactNode;
}

const useStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    ...shorthands.padding('12px', '0px', '0px'),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-start',
    ...shorthands.gap('12px'),
  },
});

export const OverviewCardFooter: FC<IFooterProps> = memo((props: IFooterProps) => {
  const {
    footerButtonConfigs,
    renderPagination,
  } = props;
  const classes = useStyles();

  return (
    <CardFooter className={classNames('ba-card-footer', classes.container)}>
      <div className={classNames('ba-card-footer-buttons', classes.buttons)}>
        {footerButtonConfigs?.map((config) => {
          const hiddenButton = useRef(null);
          const onClick = useCallback(() => {
            config.onClick();
            hiddenButton?.current?.click();
          }, [config, hiddenButton]);
          return (
            <React.Fragment key={config.text}>
              <Button
                key={config.text}
                appearance={config.appearance}
                onClick={onClick}
                className={config.className}
                {...(config.analyticsId ? { 'data-analyticsid': config.analyticsId } : {})}
              >
                {config.text}
              </Button>
              {config.helpId && <button className="HelpTopic" {...{ query: config.helpId }} hidden ref={hiddenButton} />}
            </React.Fragment>
          );
        })}
      </div>
      {renderPagination && renderPagination()}
    </CardFooter>
  );
});

OverviewCardFooter.displayName = 'OverviewCardFooter';
OverviewCardFooter.defaultProps = {
  footerButtonConfigs: [],
  renderPagination: undefined,
};
